import { render } from "./BroneeriView.vue?vue&type=template&id=5e987f45&scoped=true&lang=pug"
import script from "./BroneeriView.vue?vue&type=script&lang=js"
export * from "./BroneeriView.vue?vue&type=script&lang=js"

import "./BroneeriView.vue?vue&type=style&index=0&id=5e987f45&scoped=true&lang=scss"

import exportComponent from "/Applications/DEV/kevin/GIT/monafoto.ee/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e987f45"]])

export default __exports__